import axios from 'axios';

export const fetchLocations = () => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get(`/api/locations.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_LOCATIONS', locations: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const fetchLocation = (id) => {
  return (dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get(`/api/locations/${id}.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_LOCATION', location: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}

export const fetchUsers = (id) => {
  return(dispatch, getState) => {
    let headers = {"Content-Type": "application/json"};
    let {token} = getState().auth;
    if (token) {
      headers["Authorization"] = `JWT ${token}`;
    }

    return axios.get(`/api/locations/${id}/users.json`, {headers})
      .then(res => {
        return dispatch({type: 'FETCH_USERS', users: res.data});
      }).catch(function (error) {
        if(error.response.status === 401 || error.response.status === 403) {
          dispatch({type: "AUTHENTICATION_ERROR", data: error.response.data});
        } else {
          console.log(`${error.response.status} Server Error!`);
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/locations.js